import TransactionWorkspace from "./TransactionWorkspace.jsx";
import { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { useReactToPrint } from "react-to-print";
import { serverHost } from "../../../../http_common.js";
import { purchaseSummary, purchaseDate, purchaseAmount } from "./exports/OrdersPDFExport.jsx";
import { matchesPurchaseFilters } from "./filters/FilterOders.jsx";
import PurchaseOrdersPreview from "./previews/PreviewPurchseOrders.jsx";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import "./orders.css";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import * as Action from "../../../../store/redux/client_reducer.js";
import { useSnackbar } from "notistack";
// >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>

import IsLoading from "../../../../IsLoading.jsx";
import FilterDiscount from "./filters/FilterOders.jsx";
import ExportPDFButton from "./exports/OnDemandPDFExport.jsx";
import ExportExcelJSButton from "./exports/OrdersExcelExport.jsx";
// @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

// import from MUI
import ShortTextIcon from "@mui/icons-material/ShortText";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import ScreenShareOutlinedIcon from "@mui/icons-material/ScreenShareOutlined";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import ListAltIcon from "@mui/icons-material/ListAlt";
import PrintIcon from "@mui/icons-material/Print";
import AppsOutlinedIcon from "@mui/icons-material/AppsOutlined";
import AddIcon from "@mui/icons-material/Add";
import CandlestickChartIcon from "@mui/icons-material/CandlestickChart";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
// image imports
import PlaceOrder from "./create/PlaceOrder.jsx";
import PurchaseOrders from "../../purchases/PurchaseOrders.jsx";


export default function Orders({
  breadcrumbs,
  data,
  dispatchPageRender,
  setIsMobileNavOpen,
}) {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [requestError, setRequestError] = useState("");
  const dispatch = useDispatch();
  const [changeview, setChangeView] = useState("grid");
  const [accordion, setAccordion] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalInfo, setModalInfo] = useState("");
  const [displayedComponent, setDisplayedComponent] = useState("main-display");

  const [ordersData, setRawRecords] = useState([]);
  const [filters, setFilters] = useState({ rules: [], sort: "newest", from: "", to: "" });
  const [selectedRecord, setSelectedRecord] = useState(null);
    const [editingDuplicate, setEditingDuplicate] = useState(false);
  const listPrintRef = useRef(null);
  const printList = useReactToPrint({ contentRef: listPrintRef, documentTitle: "Purchase Order Records" });
  const writePending = useRef(false);
  const requestSerial = useRef(0);
  const activeClient = useRef(data?.clientId);
  activeClient.current = data?.clientId;

  // Paginations Functions
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [openLimit, setOpenLimit] = useState(false);
  const currentTab = useSelector((state) => state.clientFunction?.dashboard?.currentTab);
  const summarizedRecords=useMemo(()=>ordersData.map(record=>({record,summary:purchaseSummary(record,"order")})),[ordersData]);
  const summaryByRecord=useMemo(()=>new Map(summarizedRecords.map(({record,summary})=>[record,summary])),[summarizedRecords]);
  const filteredData = useMemo(() => {
    const now = new Date();
    const records = summarizedRecords.filter(({summary}) => {
      if (currentTab === "completed") { const date = new Date(summary.date); if (date.getMonth() !== now.getMonth() || date.getFullYear() !== now.getFullYear()) return false; }
      return matchesPurchaseFilters(summary, filters);
    });
    return records.sort((left, right) => {
      const a = left.summary, b = right.summary;
      if (filters.sort === "amount-high") return Number(b.amount || 0) - Number(a.amount || 0);
      if (filters.sort === "amount-low") return Number(a.amount || 0) - Number(b.amount || 0);
      const compare = (new Date(b.date || 0).getTime() || 0) - (new Date(a.date || 0).getTime() || 0);
      return filters.sort === "oldest" ? -compare : compare;
    }).map(({record}) => record);
  }, [summarizedRecords, filters, currentTab]);
  const totalPages = Math.max(1, Math.ceil(filteredData.length / rowsPerPage));
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  const currentRows = filteredData.slice(start, end);
  useEffect(() => { setCurrentPage((page) => Math.min(page, totalPages)); }, [totalPages]);
  useEffect(() => { setCurrentPage(1); setAccordion(null); }, [filters, currentTab]);
  useEffect(() => { setAccordion(null); }, [currentPage, rowsPerPage]);

  // /////////////////////////////////////////////////////////
  // Cross Origin Resource Sharing CRUD - Functions
  // /////////////////////////////////////////////////////////

  const apiGetOrders = useCallback(async (signal) => {
    if (!data?.clientId || activeClient.current !== data.clientId) return;
    const request = ++requestSerial.current;
    const current = () => request === requestSerial.current && activeClient.current === data.clientId && !signal?.aborted;
    setLoading(true);
    setRequestError("");
    try {
      const response = await axios.get(`${serverHost}/purchases/client/${encodeURIComponent(data.clientId)}/get_orders`, { signal });
      if (response.data.status !== 201) throw new Error(response.data.message || "Unable to load purchases.");
      if (current()) setRawRecords(Array.isArray(response.data.ordersData) ? response.data.ordersData : []);
    } catch (error) {
      if (current()) { setRawRecords([]); setRequestError(error.response?.data?.message || error.message || "Unable to load purchases."); enqueueSnackbar(error.response?.data?.message || error.message || "Unable to load purchases.", { variant: "error" }); }
    } finally { if (current()) setLoading(false); }
  }, [data?.clientId, enqueueSnackbar]);

  const openPreview = (record) => { setSelectedRecord(record); setModalInfo("previewAlpha"); setModalOpen(true); };
  const closeModal = () => { setModalOpen(false); setModalInfo(""); };
  const savedRecord = (record) => { if (record?.clientId && record.clientId !== activeClient.current) return; closeModal(); setDisplayedComponent("main-display"); setSelectedRecord(record); setCurrentPage(1); apiGetOrders(); };
  const editOrder = (record, duplicate) => { closeModal(); setSelectedRecord(record); setEditingDuplicate(duplicate); setDisplayedComponent("order-form"); };
  const cancelOrder = async (record) => {
    if (writePending.current) return;
    writePending.current = true; setLoading(true);
    try {
      const response = await axios.post(`${serverHost}/client/${encodeURIComponent(data.clientId)}/purchases/post_order`, { payload: { action: "CANCEL_ORDER", orderId: record.orderId, expectedRevision: record.revision } });
      if (response.data.status !== 200) throw new Error(response.data.message);
      if (activeClient.current !== data.clientId) return;
      setRawRecords((records) => records.map((entry) => entry.orderId === record.orderId ? response.data.info : entry));
      setSelectedRecord(response.data.info); enqueueSnackbar(response.data.message, { variant: "success" });
    } catch (error) { if (activeClient.current === data.clientId) enqueueSnackbar(error.response?.data?.message || error.message, { variant: "error" }); }
    finally { writePending.current = false; if (activeClient.current === data.clientId) setLoading(false); }
  };

  // /////////////////////////////////////////////////////////
  // Redux functions for sub-navigation
  // /////////////////////////////////////////////////////////
  function handleCurrentTAB(item) {
    dispatch(DispatchCurrentTAB(item));
  }
  const DispatchCurrentTAB = (item) => async (dispatch) => {
    try {
      dispatch(Action.dispatchCurrentTAB({ item }));
    } catch (error) {
      console.log(error?.code || "REQUEST_FAILED");
    }
  };
  // ////////////////////////////////////////////////////////////
  function getPagination(current, total) {
    if (total <= 7) {
      return Array.from({ length: total }, (_, i) => i + 1);
    }

    if (current <= 4) {
      return [1, 2, 3, 4, 5, "...", total];
    }

    if (current >= total - 3) {
      return [1, "...", total - 4, total - 3, total - 2, total - 1, total];
    }

    return [1, "...", current - 1, current, current + 1, "...", total];
  }

  function switchActiveTab() { return <ToDo />; }

  // //////////////////////////////////////////////////////////////////////////
  // COMPONENTS OF orders PAGE
  // //////////////////////////////////////////////////////////////////////////

  function ToDo() {
    function switchView() {
      switch (changeview) {
        case "grid":
          return <CardView currentRows={currentRows} />;
        case "table":
          return <TableView currentRows={currentRows} />;
        default:
          return <CardView currentRows={currentRows} />;
      }
    }
    function TableView({ currentRows }) {
      const [activeRow, setActiveRow] = useState(null);

      return (
        <div className="products">
          <table className="fx-cl spacem">
            <thead className="fx-cl spacem">
              <tr>
                <th>Order ID</th>
                <th>Supplier</th>
                <th>Warehouse</th>
                <th>Created By</th>
                <th>Approved By</th>
                <th>Sent To Supplier</th>
                <th>Expected Delivery</th>
                <th>Status</th>
                <th>Total Amount</th>
              </tr>
            </thead>
            <tbody className="fx-cl spacem">
              {currentRows?.map((item, index) => (
                <tr
                  key={item._id || (summaryByRecord.get(item) || purchaseSummary(item, "order")).id}
                  id={`${accordion == index && "productsAccordionOpen"}`}
                  className="productsRowTdCont fx-cl space1"
                >
                  <td
                    id={item?.orderId}
                    className={`productsRowTd ${activeRow == index && "active_warehauseRow"}`}
                    onClick={() => { setSelectedRecord(item); setAccordion(accordion === index ? null : index); }}
                  >
                    <span>
                      <strong>{item?.orderId}</strong>
                    </span>

                    <span>{item?.supplier?.name}</span>

                    <span>{item?.warehouse?.name}</span>

                    <span>{item?.workflow?.createdBy}</span>

                    <span>{item?.workflow?.approvedBy || "Pending"}</span>

                    <span>
                      {item?.workflow?.sentToSupplierAt
                        ? new Date(
                            item.workflow.sentToSupplierAt,
                          ).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "long",
                            year: "numeric",
                          })
                        : "Not Sent"}
                    </span>

                    <span>
                      {item?.delivery?.expectedDeliveryDate
                        ? new Date(
                            item.delivery.expectedDeliveryDate,
                          ).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "long",
                            year: "numeric",
                          })
                        : "Pending"}
                    </span>

                    <span>{item?.status?.current}</span>

                    <span>
                      {purchaseAmount(item?.pricing?.totalAmount, item?.pricing?.currency)}
                    </span>
                  </td>

                  <td className="productsAccordionCont">
                    <div className="productsAccordionDisc fx-ac space1">
                      <figure className="fx-ac fx-jc">
                        <ShoppingCartIcon
                          style={{
                            fontSize: "9.5rem",
                            color: "rgb(233 245 243)",
                          }}
                        />
                      </figure>

                      <div className="productsAccordionDetails g g4 space1">
                        <div className="fx-cl spacem">
                          <span>Order ID</span>
                          <p>
                            <strong>{item?.orderId}</strong>
                          </p>
                        </div>

                        <div className="fx-cl spacem">
                          <span>Supplier Email</span>
                          <p>
                            <strong>{item?.supplier?.email}</strong>
                          </p>
                        </div>

                        <div className="fx-cl spacem">
                          <span>Delivery Status</span>
                          <p>
                            <strong>{item?.delivery?.deliveryStatus}</strong>
                          </p>
                        </div>

                        <div className="fx-cl spacem">
                          <span>Payment Status</span>
                          <p>
                            <strong>{item?.payment?.paymentStatus}</strong>
                          </p>
                        </div>

                        <div className="fx-cl spacem">
                          <span>Total Items</span>
                          <p>
                            <strong>{item?.items?.length}</strong>
                          </p>
                        </div>

                        <div className="fx-cl spacem">
                          <span>Total Amount</span>
                          <p>
                            <strong>
                              {purchaseAmount(item?.pricing?.totalAmount, item?.pricing?.currency)}
                            </strong>
                          </p>
                        </div>

                        <div className="fx-cl spacem">
                          <span>Payment Method</span>
                          <p>
                            <strong>{item?.payment?.paymentMethod}</strong>
                          </p>
                        </div>

                        <div className="fx-cl spacem">
                          <span>Tracking Number</span>
                          <p>
                            <strong>
                              {item?.delivery?.trackingNumber || "N/A"}
                            </strong>
                          </p>
                        </div>

                        <div className="fx-cl spacem">
                          <span>Created At</span>
                          <p>
                            <strong>
                              {purchaseDate(item?.createdAt)}
                            </strong>
                          </p>
                        </div>

                        <div className="fx-ac space1">
                          <button className="controlButtons" onClick={() => openPreview(item)}>
                            <span>View Order</span>
                          </button>

                          <button className="controlButtons" onClick={() => openPreview(item)}>
                            <RemoveCircleOutlineIcon />
                            <span>Preview</span>
                          </button>

                          <ExportPDFButton kind="order" currentRows={[item]} label="Export PDF" />
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    }

    function CardView({ currentRows }) {
      return <div className="ordersCardGrid g g4 space2">{currentRows.map((item) => {
        const summary = (summaryByRecord.get(item) || purchaseSummary(item, "order"));
        return <div key={item._id || summary.id} className="ordersGridCard">
          <div className="cardHeader"><figure className="avatar fx-ac fx-jc"><ShoppingCartIcon style={{ fontSize: "3rem" }} /></figure>
            <div className="cardInfo"><h4>{summary.supplier}</h4><p>Order #{summary.id || "Not recorded"}</p>
              <div className="ratingRow"><span className="rating">{summary.status}</span><span className="location">{purchaseDate(summary.date)}</span></div>
              <small>{summary.count} lines / {summary.quantity} units</small>
            </div>
          </div>
          <div className="tags"><span>{summary.warehouse}</span><span>{item.payment?.paymentStatus || "Payment not recorded"}</span><span>{summary.currency || "Currency not recorded"}</span></div>
          <div className="cardFooter"><div className="price">{purchaseAmount(summary.amount, summary.currency)}<small> / Order</small></div><button className="cardBtn" onClick={() => openPreview(item)}>View Order</button></div>
        </div>;
      })}</div>;
    }
    return (
      <div className="fx-cl space2">
        <div className="fx-cl space2">
          <div className="fx-cl spacem">
            <div className="fx-ac fx-jb space2" style={{ fontSize: "1.2rem" }}>
              <span className="fx-ac spacem">
                <strong className="fx-jc" style={{ color: "#3a84f8" }}>
                  Display:
                </strong>
                <span>
                  {filteredData.length === 0
                    ? "0 to 0 of 0 entries"
                    : `${start + 1} to ${Math.min(
                        end,
                        filteredData.length,
                      )} of ${filteredData.length} entries`}
                </span>
              </span>
              <div className="orders_entries-info fx-ac spacem">
                <h4>Rows</h4>
                <div className="orders-page-limit">
                  <button
                    className="orders-page-limit-btn"
                    onClick={() => setOpenLimit(!openLimit)}
                  >
                    {rowsPerPage} / page
                    <span className="orders-page-limit-arrow">▾</span>
                  </button>

                  {openLimit && (
                    <ul className="orders-limit-dropdown">
                      {[10, 20, 50, 100, 200, 500, 1000].map((n) => (
                        <li
                          key={n}
                          className="orders-limit-item"
                          onClick={() => {
                            setRowsPerPage(n);
                            setCurrentPage(1);
                            setOpenLimit(false);
                          }}
                        >
                          {n} / page
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
            <div className="orders_row" id="printable">{!currentRows.length && <p>No saved purchase records match this view.</p>}
              {switchView()}
            </div>
            <div className="fx-jc">
              <div className="orders_pagination fx-ac space2">
                <button
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((p) => p - 1)}
                >
                  Previous
                </button>
                <div className="fx-ac">
                  {getPagination(currentPage, totalPages).map((page, i) =>
                    page === "..." ? (
                      <span key={i} className="dots">
                        …
                      </span>
                    ) : (
                      <button
                        key={i}
                        className={`orders_jumpto ${
                          currentPage === page ? "active" : ""
                        }`}
                        onClick={() => setCurrentPage(page)}
                      >
                        {page}
                      </button>
                    ),
                  )}
                </div>

                <button
                  disabled={currentPage >= totalPages}
                  onClick={() => setCurrentPage((p) => p + 1)}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  const applyPeriod = (period) => {
    const today = new Date(), first = new Date(today);
    let last = today;
    if (period === "week") first.setDate(today.getDate() - (today.getDay() + 6) % 7);
    if (period === "month") first.setDate(1);
    if (period === "year") first.setMonth(0, 1);
    if (period === "last-month") { first.setMonth(today.getMonth() - 1, 1); last = new Date(today.getFullYear(), today.getMonth(), 0); }
    const localDay = (date) => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
    setFilters((current) => ({ ...current, from: localDay(first), to: localDay(last) }));
    handleCurrentTAB("orders");
  };

  function handleModalFunction(toggleModal, displayModal) {
    if (toggleModal && displayModal === "previewAlpha" && !selectedRecord) { enqueueSnackbar("Select a purchase record before opening its preview.", { variant: "info" }); return; }
    setModalInfo(displayModal);
    setModalOpen(toggleModal);
  }
  function loopingModalInfo() {
    switch (modalInfo) {
      case "filters": return <FilterDiscount filters={filters} onApply={setFilters} onClose={closeModal} currentRows={filteredData} />;
      case "previewAlpha": return <PurchaseOrdersPreview premium purchaseOrderItem={selectedRecord} onClose={closeModal} onEdit={editOrder} onCancel={cancelOrder} busy={loading} />;
      case "create": return <PlaceOrder onSaved={savedRecord} onClose={closeModal} onCancel={closeModal} />;
      
      default: return null;
    }
  }
  function MobileUi({ setIsMobileNavOpen }) {
    const [showCard, setShowCard] = useState("");
    const cardRef = useRef(null);

    // Close when clicking outside
    useEffect(() => {
      const handleClickOutside = (e) => {
        if (cardRef.current && !cardRef.current.contains(e.target)) {
          setShowCard("");
        }
      };

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);
    return (
      <div
        id="mobileRWDInvDisp"
        className="salesMobileUi computerRWDhide fx-cl space3"
      >
        <div className="fx-ac fx-jb space2">
          <button onClick={() => setIsMobileNavOpen(true)}>
            <ShortTextIcon style={{ color: "#818181", fontSize: "3.8rem" }} />
          </button>
          <div className="fx-cl">
            <span className="fs3 fw500">Transactions</span>
            {/* <span className="fs1 fw200">Lorem ipsum dolor sit amet cons</span> */}
          </div>
          <div className="fx-ac fx-jc spacem" style={{ color: "#818181" }}>
            <figure>
              <PrintOutlinedIcon style={{ fontSize: "3.8rem" }} onClick={printList} />
            </figure>
            <div className="fx" style={{ position: "relative" }}>
              <button
                className="fw600 fs1"
                onClick={() => setShowCard("exports")}
              >
                <ScreenShareOutlinedIcon style={{ fontSize: "3.8rem" }} />
              </button>

              {showCard === "exports" && (
                <div ref={cardRef} className="exportsBtnDropdwn fx-cl">
                  <div className="fx-ac spacem"><ExportPDFButton kind="order" currentRows={filteredData} label="Export PDF" /></div>
                  <ExportExcelJSButton currentRows={filteredData} />
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="fx-cl spacem">
          <div className="fx-ac fx-jb space3">
            <span className="lightGrayMbl fx-jc fs1">
              {filteredData.length === 0
                ? "0 to 0 of 0 entries"
                : `${start + 1} - ${Math.min(
                    end,
                    filteredData.length,
                  )} of ${filteredData.length} `}
            </span>
            <div className="fx" style={{ position: "relative" }}>
              <button
                className="fw600 fs1"
                style={{ color: "#3a84f8" }}
                onClick={() => setShowCard("transactions")}
              >
                All transactions
              </button>

              {showCard === "transactions" && (
                <div ref={cardRef} className="exportsBtnDropdwn fx-cl">
                  <button className="fx-ac spacem" onClick={() => { applyPeriod("today"); setShowCard(""); }}>Today</button>
                  <button className="fx-ac spacem" onClick={() => { applyPeriod("week"); setShowCard(""); }}>This Week</button>
                  <button className="fx-ac spacem" onClick={() => { applyPeriod("month"); setShowCard(""); }}>This Month</button>
                  <button className="fx-ac spacem" onClick={() => { applyPeriod("last-month"); setShowCard(""); }}>Last Month</button>
                  <button className="fx-ac spacem" onClick={() => { applyPeriod("year"); setShowCard(""); }}>This year</button>
                </div>
              )}
            </div>
          </div>
          <div className="mobileUiItemsCont fx-cl space1">
            {currentRows?.map((item) => (
              <div
                className="mobileUiItemCard fx-cl"
                key={item?._id || (summaryByRecord.get(item) || purchaseSummary(item, "order")).id}
              >
                <div className="topContents fx-ac space2">
                  <figure className="mblImgCard">
                    <InsertDriveFileIcon style={{ fontSize: "3.7rem" }} />
                  </figure>

                  <div className="fx-cl spacem" style={{ flexGrow: "1" }}>
                    <span className="fw500">
                      Items: {item?.items?.length || 0}
                    </span>

                    <span className="fs1 lightGrayMbl">
                      {item?.supplier?.name || "Not recorded"}
                    </span>

                    <div className="fx-jb fx-ac">
                      <span className="fw500 fs4">
                        {purchaseAmount((summaryByRecord.get(item) || purchaseSummary(item, "order")).amount, (summaryByRecord.get(item) || purchaseSummary(item, "order")).currency)}
                      </span>

                      <span className="fs1v lightGrayMbl">
                        {(summaryByRecord.get(item) || purchaseSummary(item, "order")).status}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="bottomConts fx-ac space3 fx-jb">
                  <div className="fx-cl spacem">
                    <span className="fs1 lightGrayMbl">Id: {(summaryByRecord.get(item) || purchaseSummary(item, "order")).id}</span>
                    <span className="fs3 fw500">{purchaseDate((summaryByRecord.get(item) || purchaseSummary(item, "order")).date)}</span>
                  </div>

                  <div className="fx spacem">
                    <button
                      onClick={(e) => {
                        openPreview(item);
                      }}
                    >
                      View Order
                    </button>
                    <button
                      className="fx-ac fx-jc"
                      aria-label="Preview Order"
                      onClick={(e) => {
                        e.stopPropagation();
                        openPreview(item);
                      }}
                    >
                      <ReceiptLongIcon fontSize="large" />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="fx-jc">
            <div className="sales_pagination fx-ac space2">
              <button
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((p) => p - 1)}
              >
                Previous
              </button>
              <div className="fx-ac">
                {getPagination(currentPage, totalPages).map((page, i) =>
                  page === "..." ? (
                    <span key={i} className="dots">
                      …
                    </span>
                  ) : (
                    <button
                      key={i}
                      className={`sales_jumpto ${
                        currentPage === page ? "active" : ""
                      }`}
                      onClick={() => setCurrentPage(page)}
                    >
                      {page}
                    </button>
                  ),
                )}
              </div>

              <button
                disabled={currentPage >= totalPages}
                onClick={() => setCurrentPage((p) => p + 1)}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  function MainUi() {
    return <TransactionWorkspace
      kind="order"
      records={filteredData}
      summaryByRecord={summaryByRecord}
      filters={filters}
      onFiltersChange={setFilters}
      onAdvancedFilter={() => handleModalFunction(true, "filters")}
      onRefresh={() => apiGetOrders()}
      onPreview={openPreview}
      
      onCreate={() => dispatchPageRender("place-new-order", "place-new-order", "place-new-order")}
      loading={loading}
      error={requestError}
      view={changeview}
      onViewChange={setChangeView}
      tabs={[{value:"orders",label:"All orders"}, {value:"completed",label:"This month"}]}
      activeTab={currentTab}
      onTabChange={handleCurrentTAB}
      printRef={listPrintRef}
      onPrint={printList}
      renderExcel={records => <ExportExcelJSButton currentRows={records} />}
    />;
  }

  function controlDisplay() {
    switch (displayedComponent) {
      case "order-form":
        return <PurchaseOrders initialOrder={selectedRecord} duplicate={editingDuplicate} onSaved={savedRecord} onCancel={() => setDisplayedComponent("main-display")} />;
      case "main-display":
        return MainUi();
      case "item-previewed":
        return <PurchaseOrdersPreview premium purchaseOrderItem={selectedRecord} onClose={() => setDisplayedComponent("main-display")} />;
      default:
        return MainUi();
    }
  }
  useEffect(() => {
    const controller = new AbortController();
    setRawRecords([]); setSelectedRecord(null); closeModal(); setDisplayedComponent("main-display"); setCurrentPage(1); setFilters({ rules: [], sort: "newest", from: "", to: "" });
    apiGetOrders(controller.signal);
    return () => { controller.abort(); requestSerial.current++; };
  }, [apiGetOrders]);
  return (
    <div className="ordersCompContainer">
      {modalOpen && (
        <div
          className="client_modal_overlay fx-jc fx-ac"
          onClick={() => handleModalFunction(false, "")} // click outside → close
        >
          <div
            className="client_modal"
            onClick={(e) => e.stopPropagation()} // click inside → stay open
          >
            {loopingModalInfo()}
          </div>
        </div>
      )}
      {controlDisplay()}
    </div>
  );
}
